export enum RequestState {
    InProgress = 'inProgress',
    Error = 'error',
    Success = 'success'
  }
